/* ============================================================================
   TL · KARUZELA OPINII — jeden skrypt na CALY sklep (layout/theme.liquid)
   Wlasciciel 19.09: "na kompie nie wszedzie dziala przesuwanie opinii,
   napraw to raz a dobrze na kazdej stronie".

   Dlaczego wczesniej nie dzialalo: kazda sekcja opinii wstrzykiwala wlasny
   <script> z nasluchem na przyciskach, a skora karty podmieniala te przyciski
   swoim klonem. Kolejnosc wykonania zalezala od tego, kiedy Shopify wstrzyknie
   sekcje - na czesci stron nasluch ladowal na elemencie, ktorego juz nie bylo.

   Teraz: DELEGACJA na dokumencie. Nasluch jest jeden, na <document>, wiec dziala
   niezaleznie od kolejnosci ladowania, dziala po przeladowaniu sekcji przez
   edytor motywu i po podmianie DOM. Nie trzyma referencji do przyciskow.
   ============================================================================ */
(function () {
  'use strict';

  var TOR = '.opinie-sople__track, .tl2-op__track';
  var PRZYCISK = '.opinie-sople__nav, .tl2-op__btn, [data-op-prev], [data-op-next]';

  function znajdzTor(btn) {
    var sekcja = btn.closest('.opinie-sople, .tl2-op, .shopify-section') || document;
    return sekcja.querySelector(TOR);
  }

  function wstecz(btn) {
    return /--prev/.test(btn.className) || btn.hasAttribute('data-op-prev') ||
           /‹|◄|←/.test(btn.textContent || '');
  }

  function krok(tor) {
    var karta = tor.firstElementChild;
    var szer = karta ? karta.getBoundingClientRect().width : 0;
    // jedna karta + odstep, ale nigdy mniej niz 85% okna karuzeli
    var styl = window.getComputedStyle(tor);
    var odstep = parseInt(styl.columnGap || styl.gap || '24', 10) || 24;
    return Math.max(szer + odstep, tor.clientWidth * 0.85, 300);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest(PRZYCISK) : null;
    if (!btn) return;
    var tor = znajdzTor(btn);
    if (!tor) return;
    e.preventDefault();
    var d = krok(tor);
    tor.scrollBy({ left: wstecz(btn) ? -d : d, behavior: 'smooth' });
  }, true);

  // Strzalki klawiatury, gdy karuzela ma ognisko - dostepnosc bez dodatkowego kodu.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var tor = e.target.closest ? e.target.closest(TOR) : null;
    if (!tor) return;
    e.preventDefault();
    var d = krok(tor);
    tor.scrollBy({ left: e.key === 'ArrowLeft' ? -d : d, behavior: 'smooth' });
  });

  // Wygaszanie strzalek na koncach toru - zeby bylo widac, ze nie ma juz nic dalej.
  function odswiezStrzalki(tor) {
    var sekcja = tor.closest('.opinie-sople, .tl2-op, .shopify-section');
    if (!sekcja) return;
    var koniec = tor.scrollWidth - tor.clientWidth - tor.scrollLeft < 4;
    var poczatek = tor.scrollLeft < 4;
    sekcja.querySelectorAll(PRZYCISK).forEach(function (b) {
      var w = wstecz(b);
      b.toggleAttribute('disabled', w ? poczatek : koniec);
    });
  }

  function podepnij() {
    document.querySelectorAll(TOR).forEach(function (tor) {
      if (tor.dataset.tlOpinie) return;
      tor.dataset.tlOpinie = '1';
      tor.setAttribute('tabindex', '0');
      odswiezStrzalki(tor);
      tor.addEventListener('scroll', function () { odswiezStrzalki(tor); }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', podepnij);
  } else {
    podepnij();
  }
  document.addEventListener('shopify:section:load', podepnij);
  window.addEventListener('resize', podepnij);
})();
